<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30" @click="saerchDataAdvanced()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>

           <v-col cols="6">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class=" white--text"
                @click="exportData()"
              >
                Download
                <v-icon right dark> mdi-cloud-download </v-icon>
              </v-btn>
            </v-col>

          <!-- edit -->
          <v-dialog v-model="dialogApprove" persistent max-width="80%">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col cols="12">
                    <v-row style="height: 50px">
                      <v-subheader>ผู้จัดการสาขา:</v-subheader>
                    </v-row>
                    <v-col class="d-flex" cols="12">
                      <v-combobox
                        v-model="formUpdate.empCodeBranchManager"
                        dense
                        outlined
                         clearable
              clear-icon="mdi-close-circle"
                        :items="empApproveItem"
                      ></v-combobox>
                    </v-col>
                    <v-row style="height: 50px">
                      <v-subheader>ผู้จัดการ HR:</v-subheader>
                    </v-row>
                    <v-col class="d-flex" cols="12">
                      <v-combobox
                        v-model="formUpdate.empCodeWelfareApprover"
                        dense
                        outlined
                         clearable
              clear-icon="mdi-close-circle"
                        :items="empApproveItem"
                      ></v-combobox>
                    </v-col>

                    <v-data-table
                      :headers="headers"
                      :items="selected"
                      :items-per-page="15"
                      class="elevation-1"
                    ></v-data-table>
                  </v-col>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed @click="dialogApprove = false, clearData()">
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn elevation="2" depressed color="success" @click.stop="updateApprove()">
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="dialogApprove = true "
                  >
                  <v-icon dark>
                    mdi-pencil
                  </v-icon>
                    จัดการผู้อนุมัติ
                  </v-btn>
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  v-model="selected"
                  :headers="columns"
                  :items="dataItem"
                  :single-select="singleSelect"
                  item-key="empCode"
                  show-select
                  class="elevation-1"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                             color="question"
                              fab
                              small
                              @click.stop="(dialogApprove = true), getDataById(item)"
                          >
                            <v-icon dark> mdi-tools </v-icon>
                          </v-btn>
                        </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/approve_permission/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Approve',
          disabled: false,
          href: '/HRM/Approve/ApprovePermission'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      BranchItem: [], // สาขา
      Branch: '', // สาขา
      DepartmentItem: [], // แผนก
      Department: '', // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      disableSearch: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogApprove: false,
      selected: [],
      empApproveItem: [],
      singleSelect: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        empCode: '',
        empCodeBranchManager: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        empCode: '',
        empCodeBranchManager: '',
        empCodeWelfareApprover: ''
      },
      formUpdate: {
        empCode: '',
        empCodeBranchManager: '',
        empCodeWelfareApprover: ''
      },
      formUpdateItem: {
        empCode: '',
        empCodeBranchManager: '',
        empCodeWelfareApprover: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', align: 'start', sortable: false, value: 'empCode' },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'รหัสผจกสาขา', value: 'empCodeBranchManager' },
        { text: 'ผู้จัดการสาขา', value: 'empFull_NameTH_manager' },
        { text: 'รหัสผจกHR', value: 'empCodeWelfareApprover' },
        { text: 'ผู้จัดการ HR', value: 'empFull_NameTH_HRapprove' },
        {
          text: 'แก้ไข',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem: [],
      // End Data Table Config
      headers: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'รหัสผจกสาขา', value: 'empCodeBranchManager' },
        { text: 'ผู้จัดการสาขา', value: 'empFull_NameTH_manager' },
        { text: 'รหัสผจกHR', value: 'empCodeWelfareApprover' },
        { text: 'ผู้จัดการ HR', value: 'empFull_NameTH_HRapprove' }
      ]
    }
  },
  async mounted () {
    await this.getGetToken()
    this.dataReady = false
    // Get Data
    // this.getDataGlobal(this.DNS_IP, this.path)
    await this.reload()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async reload () {
      await this.getData()
      await this.getDataEmpApprove()
      await this.getDataCompany()
      await this.getDataBranch()
      await this.getDataDepartment()
    },
    async getData () {
      this.dataReady = false
      this.selected = []
      this.dataItem = []

      var Company = (this.Company === '' ? '' : 'masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?' +
                Company +
                Branch +
                Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      this.selected = []
      this.selected.push(item)
      if (item.empCodeBranchManager) {
        var objApprove = {}
        objApprove.value = item.empCodeBranchManager
        objApprove.text = ' [' + item.empCodeBranchManager + '] ' + item.empFull_NameTH_manager + ' [' + item.masDepartmentName_manager + '] '
        this.formUpdate.empCodeBranchManager = objApprove
      }
      if (item.empCodeWelfareApprover) {
        var objVerify = {}
        objVerify.value = item.empCodeWelfareApprover
        objVerify.text = ' [' + item.empCodeWelfareApprover + '] ' + item.empFull_NameTH_HRapprove + ' [' + item.masDepartmentName_HRapprove + '] '
        this.formUpdate.empCodeWelfareApprover = objVerify
      }
    },
    async getDataEmpApprove () {
      // Clear Data ทุกครั้ง
      this.empApproveItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee/getHeader',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              // s = d.empFull_NameTH
              s.value = d.empCode
              s.text = ' [' + d.empCode + '] ' + d.empFull_NameTH + ' [' + d.masDepartmentName + '] '
              this.empApproveItem.push(s)
            }
          } else {
            this.empApproveItem = []
          }
        })
    },
    async updateApprove () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ยืนยันข้อมูลผู้อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dialogApprove = false
          var count = this.selected.length
          var i = 0
          await this.selected.forEach(async element => {
            let dt = {
              empCode: element.empCode,
              empCodeBranchManager: (this.formUpdate.empCodeBranchManager) ? this.formUpdate.empCodeBranchManager.value : null,
              empCodeWelfareApprover: (this.formUpdate.empCodeWelfareApprover) ? this.formUpdate.empCodeWelfareApprover.value : null,
              LAST_USER: this.session.data.userName
            }
            axios
              .post(
              // eslint-disable-next-line quotes
                this.DNS_IP + "/approve_permission/updateWelfare",
                dt,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
            i += 1
          })
          if (count === i) {
            await this.clearData()
          }
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
      // console.log(element.empCode)
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async saerchDataAdvanced () {
      await this.reload()
    },
    async clear () {
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      this.selected = []
      await this.reload()
    },
    async clearData () {
      this.selected = []
      this.formAdd.empCodeBranchManager = null
      this.formAdd.empCodeBranchManager = null
      this.formAdd.empCodeWelfareApprover = null
      this.formUpdate.empCodeBranchManager = null
      this.formUpdate.empCodeWelfareApprover = null
      await this.reload()
    },
    async exportData () {
      var dataItme = []
      this.dataItem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'สาขา': element.masBranchName,
          'แผนก': element.masDepartmentName,
          'ตำแหน่ง': element.positionName,
          'รหัสผจกสาขา': element.empCodeBranchManager,
          'ผู้จัดการสาขา': element.empFull_NameTH_manager,
          'รหัสผจกHR': element.empCodeWelfareApprover,
          'ผู้จัดการ HR': element.empFull_NameTH_HRapprove
        }
        dataItme.push(s)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายการคำขอ') // sheetAName is name of Worksheet
      XLSX.writeFile(
        wb,
        'รายการผู้อนุมัติสวัสดิการ.xls'
      ) // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Approve/ApproveWelfare.vue